import { createContext, FunctionComponent } from 'preact';
import { useContext } from 'preact/hooks';
import { GlobalConfig } from './interfaces/GlobalConfig.interface';
import { Configs } from './interfaces/WidgetConfigs.interface';

type GlobalConfigContextValue = {
  globalConfig: GlobalConfig;
};

const GlobalConfigContext = createContext<GlobalConfigContextValue>(null);

interface IGlobalConfigContext {
  contextValue: GlobalConfigContextValue;
  children: React.ReactNode;
}

const GlobalConfigProvider: FunctionComponent<IGlobalConfigContext> = ({
  contextValue,
  children,
}) => {
  return (
    <GlobalConfigContext.Provider value={contextValue}>
      {children}
    </GlobalConfigContext.Provider>
  );
};

export const useGlobalConfigContext = (): GlobalConfig => {
  const globalConfigCtx = useContext(GlobalConfigContext);
  return globalConfigCtx?.globalConfig;
};

export const usePTPConfigContext = (): Configs => {
  const ctx = useContext(GlobalConfigContext);
  return ctx?.globalConfig?.config;
};

export default GlobalConfigProvider;
